<template>
    <div class="flex w-full largeMax:flex-col large:justify-center">
        <div
            v-if="config?.content?.image && config?.content.image2x"
            class="large:shrink-0 large:order-last large:w-[36.125rem] large:h-full"
        >
            <img
                class="w-full h-full aspect-[6/5] object-cover"
                :srcset="`${config.content.image} 1x,
                          ${config.content.image2x} 2x`"
                :src="config.content.image"
                width="355"
                height="296"
                :alt="config?.config?.imageAlt || ''"
                loading="eager"
            >
        </div>
        <div class="bg-white large:shrink-0 large:w-full large:max-w-[36.125rem]">
            <div class="flex flex-col justify-center py-[1.875rem] px-5 large:box-border large:py-10 large:px-[3.75rem] large:h-full">
                <div class="flex flex-col items-center gap-y-[0.625rem] mb-4 large:gap-y-[0.875rem]">
                    <span class="text-[0.75rem] font-medium leading-[1.14] tracking-[0.07em] uppercase xLarge:text-[0.875rem]">
                        {{ $root.config.translations.misc.didYouKnow }}
                    </span>
                    <div
                        v-if="config?.content?.icon && config?.content?.icon2x"
                        class="w-6"
                    >
                        <img
                            class="w-full aspect-[4/5]"
                            :srcset="`${config.content.icon} 1x,
                                      ${config.content.icon2x} 2x`"
                            :src="config.content.icon"
                            width="24"
                            height="30"
                            alt=""
                            loading="eager"
                        >
                    </div>
                </div>
                <div class="flex flex-col gap-y-3 xLarge:gap-y-[0.875rem]">
                    <h1
                        v-if="config?.content?.title"
                        class="heading-s text-center"
                    >
                        {{ config.content.title }}
                    </h1>
                    <div
                        v-if="config?.content?.text"
                        class="wysiwyg body-s text-center"
                        v-html="textHtml"
                    />
                </div>
                <div class="flex flex-col items-center gap-y-3 mt-[1.875rem] large:mt-10">
                    <button
                        class="button button--outline-black relative z-0 overflow-hidden"
                        @click="skipCountdown"
                    >
                        <span>
                            <template v-if="config.isLastQuestion">
                                {{ $root.config.translations.misc.skipToResults }} ›
                            </template>
                            <template v-else>
                                {{ $root.config.translations.misc.skipToNextQuestion }} ›
                            </template>
                        </span>
                        <div
                            class="absolute inset-0 z-10 flex justify-center items-center bg-[#1D1D1D] animate-[interrupt-progress-animation_var(--duration)_linear]"
                            :style="`--duration: ${countdownFrom}s;`"
                            aria-hidden="true"
                        >
                            <span class="text-text2">
                                <template v-if="config.isLastQuestion">
                                    {{ $root.config.translations.misc.skipToResults }} ›
                                </template>
                                <template v-else>
                                    {{ $root.config.translations.misc.skipToNextQuestion }} ›
                                </template>
                            </span>
                        </div>
                    </button>
                    <div
                        class="text-[0.625rem] leading-[1.2] font-bold tracking-[0.08em] uppercase"
                        :class="{'invisible': !countdown}"
                    >
                        {{ $root.config.translations.misc.skippingIn }} <span class="text-[#A6ADB4]">{{ countdown }}</span> <template v-if="countdown > 1">{{ $root.config.translations.misc.seconds }}</template><template v-else>{{ $root.config.translations.misc.second }}</template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            config: {
                type: Object
            }
        },
        data() {
            return {
                countdownFrom: 15,
                countdown: 15,
                countdownTimer: null
            }
        },
        computed: {
            textHtml() {
                // Unescapes HTML entities
                const tempEl = document.createElement('textarea');
                tempEl.innerHTML = this.config.content.text;

                // Parses as DOM so values can be changed
                const parser = new DOMParser();
                let htmlBody = parser.parseFromString(tempEl.value, 'text/html');

                // Returns modified parsed HTML
                return htmlBody.body.innerHTML;
            }
        },
        mounted() {
            this.countdownTimer = setInterval(() => {
                this.countdown = this.countdown - 1;
                if (this.countdown === 0) {
                    this.countdownTimer = null;
                    this.$emit('goToNext');
                }
            }, 1000);
        },
        methods: {
            skipCountdown() {
                clearInterval(this.countdownTimer);
                this.countdownTimer = null;
                this.$emit('goToNext');
            }
        }
    };
</script>

<style>
    @keyframes interrupt-progress-animation {
        0% {
            clip-path: rect(0% 0% 100% 0%);
        }
        100% {
            clip-path: rect(0% 100% 100% 0%);
        }
    }
</style>
